import typeaheadSelectView from './typeaheadSelectComponent.html';
import './typeaheadSelectComponent.css';

export function typeaheadSelectComponent() {
	return {
		bindings: {
			model: '=',
			items: '<?',
			provider: '<?',
			placeholder: '@?',
			minChars: '<?',
			maxItems: '<?',
			emptyVals: '=?',
			emptyPrompt: '@?',
			debounce: '=?',
			onChoose: '&?',
		},
		controllerAs: 'vm',
		controller: typeaheadSelectComponentCtrl,
		template: typeaheadSelectView,
	};
}

export class typeaheadSelectComponentCtrl {
	constructor($scope) {
		'ngInject';
		$scope.$watch('vm.model', this.updateItemText.bind(this));
	}

	$onInit() {
		this.updateItemText();
	}

	updateItemText() {
		if (this.model) {
			this.itemText = this.model.$label || this.model.$search;
		} else {
			this.itemText = '';
		}
	}

	handleChoice(choice) {
		this.model = choice;
		this.updateItemText();
		this.onChoose && this.onChoose({ $choice: choice });
	}
}
